export function getTintFilterForHue(hueRotation: number | string): string {
    const hue = `hue-rotate(${hueRotation}deg)`
    return (hueRotation !== null && hueRotation !== "none") ? `sepia(90%) saturate(300%) brightness(80%) ${hue}` : "";
}